import { createContext } from 'react'

export const PitazoContext = createContext()
